import  request  from '@/utils/request'

export function getBannerList() {
  return request({
    url: '/Banner/get',
    method: 'post',
  })
}

export function getCompanyInfo() {
  return request({
    url: '/Homepage/get',
    method: 'post'
  })
}

// 搜索
export function getSearchList(data) {
  return request({
    url: '/Search/search',
    method: 'post',
    data
  })
}

// 获取热门专题
export function getHotTopicList() {
  return request({
    url: '/Homepage/getInfo',
    method: 'post'
  })
}